document.addEventListener("click", function (e) {
  /* =========================
     1) SOLO SCROLL PAGINA su click thumbnail
     ========================= */
  const btn = e.target.closest("[data-scroll-to]");
  if (btn) {
    // ⛔ blocca TUTTI i listener del tema (slide, focus, ecc.)
    e.preventDefault();
    e.stopImmediatePropagation();

    const selector = btn.getAttribute("data-scroll-to");
    if (!selector) return;

    const target = document.querySelector(selector);
    if (!target) return;

    target.scrollIntoView({ behavior: "smooth", block: "start" });

    // Correzione per header sticky/fixed
    const header = document.querySelector(".header, .site-header, [data-header]");
    if (header) {
      const style = getComputedStyle(header);
      if (style.position === "sticky" || style.position === "fixed") {
        const offset = Math.round(header.getBoundingClientRect().height) + 12;
        setTimeout(() => window.scrollBy({ top: -offset, behavior: "smooth" }), 250);
      }
    }
    return; // importantissimo: non far proseguire oltre
  }

  /* =========================
     2) SCROLL MINIATURE con freccette su/giu
     ========================= */
  const up = e.target.closest(".thumb-scroll-up");
  const down = e.target.closest(".thumb-scroll-down");
  if (!up && !down) return;

  e.preventDefault();

  // trova il blocco thumbnails più vicino
  const thumbsRoot = (up || down).closest(".product-thumbnails");
  if (!thumbsRoot) return;

  const container = thumbsRoot.querySelector("[data-scroll-container]");
  if (!container) return;

  const axis = container.getAttribute("data-axis") || "vertical"; // vertical/horizontal

  // quanto scrollare: 3 thumbnail circa (tweakabile)
  const step = Math.round(container.clientHeight * 0.75);

  if (axis === "horizontal") {
    container.scrollBy({ left: down ? step : -step, behavior: "smooth" });
  } else {
    container.scrollBy({ top: down ? step : -step, behavior: "smooth" });
  }
});
/* =========================
   3) FRECCE GALLERIA MOBILE (← →)
   ========================= */
(function () {
  function initMobileArrows(root) {
    const scope = root || document;

    scope.querySelectorAll('[js-product-media]').forEach(function (mediaContainer) {
      // Evita doppia inizializzazione
      if (mediaContainer.dataset.arrowsInit === '1') return;
      mediaContainer.dataset.arrowsInit = '1';

      const slider  = mediaContainer.querySelector('.product-media__items');
      const btnPrev = mediaContainer.querySelector('.product-media__arrow--left');
      const btnNext = mediaContainer.querySelector('.product-media__arrow--right');

      if (!slider || !btnPrev || !btnNext) return;

      function getItemWidth() {
        const first = slider.querySelector('[js-media-item-wrapper]');
        return first ? first.offsetWidth : slider.offsetWidth;
      }

      function updateArrows() {
        const { scrollLeft, scrollWidth, offsetWidth } = slider;
        btnPrev.classList.toggle('is-hidden', scrollLeft <= 4);
        btnNext.classList.toggle('is-hidden', scrollLeft + offsetWidth >= scrollWidth - 4);
      }

      btnPrev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        slider.scrollBy({ left: -getItemWidth(), behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        slider.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateArrows, { passive: true });

      updateArrows(); // stato iniziale
    });
  }

  // Caricamento normale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMobileArrows(); });
  } else {
    initMobileArrows();
  }

  // Quick view / section reload dinamico
  document.addEventListener('shopify:section:load', function (e) {
    initMobileArrows(e.target);
  });
})();

/* =========================
   4) SMART SCROLL — galleria vs pagina
   ========================= */
(function () {
  function initSmartScroll() {
    const mediaContainer = document.querySelector('[js-product-media]');
    if (!mediaContainer) return;
    if (mediaContainer.dataset.smartScroll === '1') return;
    mediaContainer.dataset.smartScroll = '1';

    const thumbContainer = mediaContainer.querySelector('[data-scroll-container]');
    const mainSlider = mediaContainer.querySelector('.product-media__items');

    // Blocca scroll pagina SOLO quando il mouse è dentro la galleria
    mediaContainer.addEventListener('wheel', function (e) {
      const hovered = document.elementFromPoint(e.clientX, e.clientY);
      if (!hovered) return;

      const isOverThumb = thumbContainer && thumbContainer.contains(hovered);
      const isOverMain  = mainSlider && mainSlider.contains(hovered);

      if (isOverThumb) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const axis = thumbContainer.getAttribute('data-axis') || 'vertical';
        if (axis === 'horizontal') {
          thumbContainer.scrollBy({ left: e.deltaY, behavior: 'smooth' });
        } else {
          thumbContainer.scrollBy({ top: e.deltaY, behavior: 'smooth' });
        }
        return;
      }

      if (isOverMain) {
        const canScroll = mainSlider.scrollWidth > mainSlider.clientWidth;
        if (!canScroll) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        mainSlider.scrollBy({ left: e.deltaY, behavior: 'smooth' });
        return;
      }

      // Mouse fuori da thumb e main → lascia scorrere la pagina
      // NON chiamare preventDefault() → browser gestisce normalmente

    }, { passive: false, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartScroll);
  } else {
    initSmartScroll();
  }

  document.addEventListener('shopify:section:load', initSmartScroll);
})();